let prefetchPromise = null;

/** Cache @mediapipe/face_mesh JS so FaceProcessor cold start is shorter. */
export function prefetchFaceMeshModule() {
  if (!prefetchPromise) {
    prefetchPromise = import('@mediapipe/face_mesh').catch(() => {});
  }
  return prefetchPromise;
}
